import React from "react";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import styles from "assets/jss/elite-feats-cms/components/tableStyle";

const useStyles = makeStyles(styles);

interface TableRowObject {
  color?: string;
  data?: React.ReactNode[];
  total?: boolean;
  purchase?: boolean;
  colspan?: number;
  amount?: React.ReactNode;
  col?: { colspan?: number; text?: React.ReactNode };
}

type TableRowData = React.ReactNode[] | TableRowObject;

interface CustomTableProps {
  tableHeaderColor?:
    | "warning" | "primary" | "danger" | "success" | "info" | "rose" | "gray";
  tableHead?: string[];
  tableData?: TableRowData[];
  hover?: boolean;
  coloredColls?: number[];
  colorsColls?: string[];
  customCellClasses?: string[];
  customClassesForCells?: number[];
  customHeadCellClasses?: string[];
  customHeadClassesForCells?: number[];
  striped?: boolean;
  tableShopping?: boolean;
}

export default function CustomTable(props: CustomTableProps): React.ReactElement {
  const classes = useStyles();
  const {
    tableHead,
    tableData,
    tableHeaderColor,
    hover,
    colorsColls,
    coloredColls,
    customCellClasses,
    customClassesForCells,
    striped,
    tableShopping,
    customHeadCellClasses,
    customHeadClassesForCells,
  } = props;
  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor as string]}>
            <TableRow className={classes.tableRow + " " + classes.tableRowHead}>
              {tableHead!.map((prop, key) => {
                const tableCellClasses =
                  classes.tableHeadCell +
                  " " +
                  classes.tableCell +
                  " " +
                  cx({
                    [customHeadCellClasses![
                      customHeadClassesForCells!.indexOf(key)
                    ]]: customHeadClassesForCells!.indexOf(key) !== -1,
                    [classes.tableShoppingHead]: tableShopping,
                    [classes.tableHeadFontSize]: !tableShopping,
                  });
                return (
                  <TableCell
                    className={tableCellClasses}
                    key={key}
                    style={{ fontWeight: 1000 }}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData!.map((prop: TableRowData, key) => {
            var rowColor = "";
            var rowColored = false;
            if ((prop as TableRowObject).color !== undefined) {
              rowColor = (prop as TableRowObject).color!;
              rowColored = true;
              prop = (prop as TableRowObject).data!;
            }
            const tableRowClasses = cx({
              [classes.tableRowBody]: true,
              [classes.tableRowHover]: hover,
              [classes[rowColor + "Row"]]: rowColored,
              [classes.tableStripedRow]: striped && key % 2 === 0,
            });
            if ((prop as TableRowObject).total) {
              return (
                <TableRow key={key} hover={hover} className={tableRowClasses}>
                  <TableCell
                    className={classes.tableCell}
                    colSpan={(prop as TableRowObject).colspan}
                  />
                  <TableCell
                    className={classes.tableCell + " " + classes.tableCellTotal}
                  >
                    Total
                  </TableCell>
                  <TableCell
                    className={
                      classes.tableCell + " " + classes.tableCellAmount
                    }
                  >
                    {(prop as TableRowObject).amount}
                  </TableCell>
                  {tableHead!.length - ((prop as TableRowObject).colspan! - 0 + 2) > 0 ? (
                    <TableCell
                      className={classes.tableCell}
                      colSpan={tableHead!.length - ((prop as TableRowObject).colspan! - 0 + 2)}
                    />
                  ) : null}
                </TableRow>
              );
            }
            if ((prop as TableRowObject).purchase) {
              return (
                <TableRow key={key} hover={hover} className={tableRowClasses}>
                  <TableCell
                    className={classes.tableCell}
                    colSpan={(prop as TableRowObject).colspan}
                  />
                  <TableCell
                    className={classes.tableCell + " " + classes.right}
                    colSpan={(prop as TableRowObject).col!.colspan}
                  >
                    {(prop as TableRowObject).col!.text}
                  </TableCell>
                </TableRow>
              );
            }
            return (
              <TableRow
                key={key}
                hover={hover}
                className={classes.tableRow + " " + tableRowClasses}
              >
                {(prop as React.ReactNode[]).map((prop, key) => {
                  const tableCellClasses =
                    classes.tableCell +
                    " " +
                    cx({
                      [classes[colorsColls![coloredColls!.indexOf(key)]]]:
                        coloredColls!.indexOf(key) !== -1,
                      [customCellClasses![customClassesForCells!.indexOf(key)]]:
                        customClassesForCells!.indexOf(key) !== -1,
                    });
                  return (
                    <TableCell className={tableCellClasses} key={key}>
                      {prop}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray",
  hover: false,
  colorsColls: [],
  coloredColls: [],
  striped: false,
  customCellClasses: [],
  customClassesForCells: [],
  customHeadCellClasses: [],
  customHeadClassesForCells: [],
};

